import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Form,
  Input,
  Select,
  Col,
  Row,
  Checkbox,
  Radio,
  AutoComplete,
  Tooltip,
  TimePicker,
} from "antd";
import {
  HaberForm,
  RightDrawerContainer,
  DetailFields,
  DownArrowDraw,
} from "../../styledElements";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import alertBlue from "../../../Assets/Icons/alertBlue.svg";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { Switch } from "antd";
import { DatePickerY, GlobalSet, Styled } from "../../pageStyled";
import moment, { weekdays } from "moment";
import styled from "styled-components";
import { getJobCardSerialNumberParam, updateJobCardSerialNumberParam } from "../../../Services/settingsServices";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { render } from "@testing-library/react";

const TimePickerStyle = styled.div`
  .ant-picker-now-btn {
    background-color: var(--theme-color);
  }
  .ant-btn-primary:hover {
    color: #fff;
    border-color: var(--theme-color);
    background: var(--theme-color);
  }
  .ant-picker-dropdown.custom-timepicker-dropdown .ant-btn-primary {
    color: #fff;
    border-color: var(--theme-color);
    background: var(--theme-color);
  }
  ant-btn ant-btn-primary ant-btn-sm {
    color: #fff;
    border-color: var(--theme-color);
    background: var(--theme-color);
  }

  .ant-btn-primary {
    color: #fff;
    border-color: var(--theme-color) !important;
    background: var(--theme-color) !important;
    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
  }
  ant-btn ant-btn-primary ant-btn-sm {
    color: #fff;
    border-color: var(--theme-color) !important;
    background: var(--theme-color) !important;
    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
  }
  .ant-picker {
    background-color: var(--form-element-bg);
    border: 2px solid #dfe1e6;
    box-sizing: border-box;
    border-radius: 8px;
    height: 40px;
    font-size: 14px;
    font-family: var(--sf-pro-text);
    color: #323130;
    box-shadow: none !important;
    overflow: hidden;
    width: 100%;
  }
`;

const JobConfigStyle = styled.div`
.ant-form-item-label {
overflow: inherit;
    white-space: unset;
}
`
const StyledTimePicker = styled(TimePicker)`
  /* Your custom styles for the TimePicker */

  // Target the .ant-btn-primary class within the TimePicker
  && .ant-picker-time-panel {
    .ant-btn-primary {
      /* Your custom styles for the primary button */
      background-color: blue; /* Change background color */
      color: white; /* Change text color */
      border-color: blue; /* Change border color */
    }
  }
`;
const defaultTime = moment("10:00", "HH:mm");
const { Option } = Select;

const indexValue = {
  0: "first",
  1: "second",
  2: "third",
  3: "forth",
  4: "fifth",
  5: "sixth",
  6: "seventh",
  7: "eighth",
};

const machineParam = [
  {
    value: "name",
    label: "Machine Name",
  },
  {
    value: "code",
    label: "Machine Code",
  },
];

const separators = [
  {
    value: ",",
    label: "Comma ,",
  },
  {
    value: ":",
    label: "Colon :",
  },
  {
    value: "-",
    label: "Hyphen -",
  },
  {
    value: "/",
    label: "Slash /",
  },
  {
    value: "|",
    label: "Vertical Bar |",
  },
  {
    value: ";",
    label: "Semicolon ;",
  },
  {
    value: " ",
    label: "Space",
  },
  {
    value: "",
    label: "None",
  },
];

const parameterList = [
  {
    value: "fixed_code",
    label: "Fixed Code",
  },
  {
    value: "year",
    label: "Year",
  },
  {
    value: "day",
    label: "Day",
  },
  {
    value: "month",
    label: "Month",
  },
  {
    value: "machine",
    label: "Paper Mchine",
  },
  {
    value: "series",
    label: "Series",
  },
];

const resetCondition = [
  {
    label: "None",
    value: "none",
  },
  {
    label: "Year Change",
    value: "year",
  },
  {
    label: "Month Change",
    value: "month",
  },
  {
    label: "Week Change",
    value: "week",
  },
];

const months = [
  {
    label: "January",
    value: "january",
  },
  {
    label: "February",
    value: "february",
  },
  {
    label: "March",
    value: "march",
  },
  {
    label: "April",
    value: "april",
  },
  {
    label: "May",
    value: "may",
  },
  {
    label: "June",
    value: "june",
  },
  {
    label: "July",
    value: "july",
  },
  {
    label: "August",
    value: "august",
  },
  {
    label: "September",
    value: "september",
  },
  {
    label: "October",
    value: "october",
  },
  {
    label: "November",
    value: "november",
  },
  {
    label: "December",
    value: "december",
  },
];

const monthType = [
  {
    label: "01,02,…11,12",
    value: "number",
  },
  {
    label: "Jan,Feb,…Nov,Dec",
    value: "name",
  },
];

const dates = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

const days = [
  {
    label: "Sunday",
    value: "sunday",
  },
  {
    label: "Monday",
    value: "monday",
  },
  {
    label: "Tuesday",
    value: "tuesday",
  },
  {
    label: "Wednesday",
    value: "wednesday",
  },
  {
    label: "Thursday",
    value: "thursday",
  },
  {
    label: "Friday",
    value: "friday",
  },
  {
    label: "Saturday",
    value: "saturday",
  },
];

const seriesHierarchy = [
  {
    label: "Plant",
    value: "plant",
  },
  {
    label: "Paper Machine",
    value: "machine",
  },
];
const isLeapYear = (year) => {
  // Leap years are divisible by 4, but not by 100 unless they are also divisible by 400
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
};

const getNextLeapYear = (currentYear) => {
  while (true) {
    currentYear++;
    if (
      (currentYear % 4 === 0 && currentYear % 100 !== 0) ||
      currentYear % 400 === 0
    ) {
      return currentYear;
    }
  }
};

const getCurrentWeekDate = (day) => {
  const daysOfWeek = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ];
  const currentDate = new Date();
  const currentDay = currentDate.getDay(); // Get the current day index (0-6)
  const targetDay = daysOfWeek.indexOf(day); // Get the target day index

  // Calculate the difference in days between the current day and the target day
  const difference = targetDay - currentDay;

  // Adjust the date by adding the difference
  const targetDate = new Date(currentDate);
  targetDate.setDate(targetDate.getDate() + difference);

  return targetDate;
};

const isDateInCurrentMonth = (givenDate) => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();

  const givenMonth = givenDate.getMonth();
  const givenYear = givenDate.getFullYear();

  return currentMonth === givenMonth && currentYear === givenYear;
};

const adjustDateForCurrentMonth = (day) => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();

  // Construct a new Date object with the current year, current month, and given day
  const givenDate = new Date(currentYear, currentMonth, day);

  // If the given day exceeds the number of days in the current month
  if (givenDate.getMonth() !== currentMonth) {
    // Increment the month by 1
    givenDate.setMonth(currentMonth + 1);
    // If the next month exceeds December, increment the year and set the month to January
    if (givenDate.getMonth() === 0) {
      givenDate.setFullYear(currentYear + 1);
    }
    // Set the date to the input day
    givenDate.setDate(day);
  }

  return givenDate;
};

function getLastDayOfMonth(month) {
  var date = new Date(new Date().getFullYear(), month + 1, 0);
  // Return the last day of the month
  return date;
}

const getLastDayOfCurrentMonth = () => {
  const currentDate = new Date();
  const nextMonthFirstDay = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    1
  );
  const lastDay = new Date(nextMonthFirstDay - 1);
  return lastDay.getDate();
};

const convertToUTC = (dateTimeString) => {
  // Create a Date object from the given date time string
  const localDate = new Date(dateTimeString);

  // Convert the local date to UTC using toISOString() method
  const utcDate = localDate.toISOString();

  return utcDate;
};

const createCustomDate = (year, month, day, hour, minute, second) => {
  // JavaScript months are zero-based, so we9 subtract 1 from the month
  const customDate = new Date(year, parseInt(month), day, hour, minute, second);
  return customDate;
};

const appendTimeToDate = (givenDate, hours, minutes, seconds, milliseconds) => {
  // Create a new Date object with the date part of the given date and the specified time
  const modifiedDate = new Date(givenDate);
  modifiedDate.setHours(hours);
  modifiedDate.setMinutes(minutes);
  modifiedDate.setSeconds(seconds);
  modifiedDate.setMilliseconds(milliseconds);
  return modifiedDate;
};

const getNextMonthDateIfExceed = (givenDate) => {
  const [year, month, day] = givenDate.split("-").map(Number);
  const date = new Date(year, month - 1, day);

  // Check if the date is valid
  if (date.getMonth() + 1 !== month) {
    return true;
  } else {
    // Valid date, return input date
    return false;
  }
};

const deepMerge =  (target, source) => {
  for (const key in source) {
    if (source[key] instanceof Object) {
      if (!target[key]) Object.assign(target, { [key]: {} });
      deepMerge(target[key], source[key]);
    } else {
      Object.assign(target, { [key]: source[key] });
    }
  }
  return target;
}


const SerialNumberConfigDrawer = (props) => {
  const [form] = Form.useForm();
  const [selectedMonth, setSelectedMonth] = useState(0);
  const [error, setError] = useState(false);
  const [alert, setAlert] = useState(false);
  const [borderIndex, setBorderIndex] = useState(null);
  const [parameterData, setParameterData] = useState();
  const paramRef = useRef();
  const paramRefOriginal = useRef();
  const [previewCode, setPreviewCode] = useState("");
  const [isSaveDisable,setIsSaveDisable] =  useState(false);
  const [parameterList, setParamaeterList] = useState([
    {
      value: "fixed_code",
      label: "Fixed Code",
    },
    {
      value: "year",
      label: "Year",
    },
    {
      value: "day",
      label: "Day",
    },
    {
      value: "month",
      label: "Month",
    },
    {
      value: "machine",
      label: "Paper Mchine",
    },
    {
      value: "series",
      label: "Series",
    },
  ]);
  const [activeList, setActiveList] = useState([false, false, false, false, false, false]);

  const isDelete = useRef(false);
  const isDragged = useRef(false);
  const userDetails = JSON.parse(localStorage.getItem("user-details"));

  useEffect(async () => {
    let params = "";
    const records = await getJobCardSerialNumberParam();
    if (records) {
      let enablePrams = [];
      let disabledParams = [];
      for (let index = 0; index < parameterList.length; index++) {
        let param = parameterList[index];
        if (
          records.data.jobcard_code_config.some(
            (obj) => obj.name === param.value
          )
        ) {
          param["disabled"] = true;
          disabledParams.push(param);
        } else {
          param["disabled"] = false;
          enablePrams.push(param);
        }
      }
      setParamaeterList([...enablePrams, ...disabledParams]);
      setParameterData(records.data.jobcard_code_config);
      paramRef.current = records.data.jobcard_code_config;
      paramRefOriginal.current = JSON.parse(JSON.stringify( records.data.jobcard_code_config)); 
    }
  }, []);

  useEffect(async () => {
    let enablePrams = [];
    let disabledParams = [];
    if (parameterData && parameterData.length) {
      if (isDelete.current || isDragged.current) {
        for (let i = 0; i < 6; i++) {
          const param = parameterData[i];
          if (param) {
            form.setFieldsValue({ [`param_type${i}`]: parameterData[i].name });
          } else {
            form.setFieldsValue({ [`param_type${i}`]: "" });
          }
        }
        form.resetFields();
        //form.validateFields();
        isDelete.current = false;
        isDragged.current = false;
      }
      for (let index = 0; index < parameterList.length; index++) {
        let param = parameterList[index];
        if (parameterData.some((obj) => obj.name === param.value)) {
          param["disabled"] = true;
          disabledParams.push(param);
        } else {
          param["disabled"] = false;
          enablePrams.push(param);
        }
      }
      setParamaeterList([...enablePrams, ...disabledParams]);

      let jcCode = "";
      for (let index = 0; index < parameterData.length; index++) {
        let param = parameterData[index];

        switch (parameterData[index].name) {
          case "fixed_code":
            jcCode =
              jcCode +
              form.getFieldValue(`code${index}`) +
              form.getFieldValue(`separator${index}`);
            break;
          case "year":
            jcCode = jcCode + "2021" + form.getFieldValue(`separator${index}`);

            break;
          case "month":
            if (form.getFieldValue(`month${index}`) == "name")
              jcCode =
                jcCode + "April" + form.getFieldValue(`separator${index}`);
            else
              jcCode = jcCode + "04" + form.getFieldValue(`separator${index}`);
            break;
          case "day":
            jcCode = jcCode + "01" + form.getFieldValue(`separator${index}`);
            break;
          case "machine":
            if (form.getFieldValue(`machine${index}`) == "name")
              jcCode =
                jcCode + "MachineEX" + form.getFieldValue(`separator${index}`);
            else
              jcCode =
                jcCode + "M1001" + form.getFieldValue(`separator${index}`);
            break;
          case "series":
            jcCode =
              jcCode +
              form.getFieldValue(`series${index}`) +
              form.getFieldValue(`separator${index}`);
            break;
        }
      }
      setPreviewCode(jcCode);
      form.setFieldsValue({ previewCode: jcCode });
      setIsSaveDisable(false);
    }
  }, [parameterData]);

  const onDeleteParamater = (index) => {
    isDelete.current = true;
    let parameters = [...paramRef.current];
    parameters.splice(index, 1);
    //   if(parameters[index])
    //   {
    //   form.setFieldsValue({ [`param_type${index}`] : parameters[index].name});
    //   }
    // else
    // {
    // form.setFieldsValue({ [`param_type${index}`] : ''});
    // }
    setParameterData([...parameters]);
    paramRef.current = [...parameters];

    let fieldName = `param_type${index}`;
  };

  const onAddParameter = () => {
    let parameters = [...paramRef.current];
    let param = {};
    switch (parameterList[0].value) {
      case "fixed_code":
        param = {
          name: "fixed_code",
          value: "",
          separator: {
            status: false,
            value: "",
          },
        };
        break;
      case "year":
        param = {
          name: "year",
          separator: {
            status: false,
            value: "",
          },
        };

        break;
      case "month":
        param = {
          name: "month",
          type: "number",
          value: "",
          separator: {
            status: false,
            value: "",
          },
        };
        break;
      case "day":
        param = {
          name: "day",
          separator: {
            status: false,
            value: "",
          },
        };
        break;
      case "machine":
        param = {
          name: "machine",
          type: "name",
          separator: {
            status: false,
            value: "",
          },
        };
        break;
      case "series":
        param = {
          name: "series",
          initiator: "",
          hierarchy: "plant",
          separator: {
            status: false,
            value: "",
          },
          reset_time: {
            status: true,
            type: "none",
            time: "",
            time_ui: {
              month_name: "april",
              month_number: 3,
              day_name: "sunday",
              day_number: "1",
              display_time: "00:00",
            },
          },
        };
        break;
    }
    parameters.push(param);
    setParameterData([...parameters]);
    paramRef.current = [...parameters];
  };

  const onParameterTypeChange = (e, paramIndex) => {
    let parameters = [...paramRef.current];
    let param = {};
    switch (e) {
      case "fixed_code":
        param = {
          name: "fixed_code",
          value: "",
          separator: {
            status: false,
            value: "",
          },
        };
        break;
      case "year":
        param = {
          name: "year",
          separator: {
            status: false,
            value: "",
          },
        };

        break;
      case "month":
        param = {
          name: "month",
          type: "number",
          value: "",
          separator: {
            status: false,
            value: "",
          },
        };
        break;
      case "day":
        param = {
          name: "day",
          separator: {
            status: false,
            value: "",
          },
        };
        break;
      case "machine":
        param = {
          name: "machine",
          type: "name",
          separator: {
            status: false,
            value: "",
          },
        };
        break;
      case "series":
        param = {
          name: "series",
          initiator: "",
          hierarchy: "plant",
          separator: {
            status: false,
            value: "",
          },
          reset_time: {
            status: true,
            type: "none",
            time: "",
            time_ui: {
              month_name: "",
              month_number: "",
              day_name: "",
              day_number: "",
              display_time: "",
            },
          },
        };
        break;
    }
    parameters[paramIndex] = { ...param };
    setParameterData([...parameters]);
    paramRef.current = [...parameters];
  };

  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      const context = this;
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        timeout = null;
        func?.apply(context, args);
      }, wait);
    };
  }

  const isNumeric =(str) => {
    if (typeof str != "string") return false; // we only process strings
    return !isNaN(str) && !isNaN(parseFloat(str));
  }
  const onFormValueChange = async(values, allvalues) => {
  // await form.validateFields();
  let  index = paramRef.current.findIndex(data => data.name ==="series"); 
  let  indexCode = paramRef.current.findIndex(data => data.name ==="fixed_code")
  if((indexCode != -1 && values['code'+indexCode] && values['code'+indexCode].length > 6) || (values['series'+index] && (values['series'+index].length > 8 || !isNumeric(values['series'+index]))) || (allvalues['series'+index] && (allvalues['series'+index].length > 8 || !isNumeric(allvalues['series'+index]))) || (allvalues['code'+indexCode] && ( allvalues['code'+indexCode].length > 6 || !/^[a-zA-Z0-9]+$/.test(allvalues['code'+indexCode]))) )
    {
      return;
    }
   else if (
      !values.param_type0 &&
      !values.param_type1 &&
      !values.param_type2 &&
      !values.param_type3 &&
      !values.param_type4 &&
      !values.param_type5 
    ) {
      let parameters = [...paramRef.current];
      for (let index = 0; index < paramRef.current.length; index++) {
        const param = paramRef.current[index];
        let paramCopy = {...param};
        let updatedParam = {};
        switch (paramRef.current[index].name) {
          case "fixed_code":
            updatedParam = {
              name: "fixed_code",
              value: allvalues[`code${index}`],
              separator: {
                status: allvalues[`separator${index}`] ? true : false,
                value: allvalues[`separator${index}`],
              },
            };
            break;
          case "year":
            updatedParam = {
              name: "year",
              separator: {
                status: allvalues[`separator${index}`] ? true : false,
                value: allvalues[`separator${index}`],
              },
            };

            break;
          case "month":
            updatedParam = {
              name: "month",
              type: allvalues[`month${index}`],
              value: "",
              separator: {
                status: allvalues[`separator${index}`] ? true : false,
                value: allvalues[`separator${index}`],
              },
            };
            break;
          case "day":
            updatedParam = {
              name: "day",
              separator: {
                status: allvalues[`separator${index}`] ? true : false,
                value: allvalues[`separator${index}`],
              },
            };
            break;
          case "machine":
            updatedParam = {
              name: "machine",
              type: allvalues[`machine${index}`],
              separator: {
                status: allvalues[`separator${index}`] ? true : false,
                value: allvalues[`separator${index}`],
              },
            };
            break;
          case "series":
            updatedParam = {
              name: "series",
              // machines_used : param.machines_used,
              initiator: allvalues[`series${index}`],
              hierarchy: allvalues[`series_hierarchy`],
              separator: {
                status: allvalues[`separator${index}`] ? true : false,
                value: allvalues[`separator${index}`],
              },
              reset_time: {
                status: true,
                type: allvalues[`reset_condition`],
                time: "",
                time_ui: {
                  month_name:
                    allvalues[`reset_condition`] == "year"
                      ? allvalues[`year_month`]
                        ? allvalues[`year_month`]
                        : "april"
                      : "april",
                  month_number:
                    allvalues[`reset_condition`] == "year" &&
                    allvalues[`year_month`]
                      ? months.findIndex(
                          (obj) => obj.value === allvalues[`year_month`]
                        )
                      : 3,
                  day_name:
                    allvalues[`reset_condition`] == "week" &&
                    allvalues[`week_day`]
                      ? allvalues[`week_day`]
                      : "monday",
                  day_number:
                    allvalues[`reset_condition`] == "year" &&
                    allvalues[`year_day`]
                      ? allvalues[`year_day`]
                      : allvalues[`reset_condition`] == "month" &&
                        allvalues[`month_day`]
                      ? allvalues[`month_day`]
                      : "1",
                  display_time:
                    allvalues[`reset_condition`] == "year" &&
                    allvalues[`year_time`]
                      ? param.reset_time.time_ui.display_time
                      : allvalues[`month_time`]
                      ? param.reset_time.time_ui.display_time
                      : param.reset_time.time_ui.display_time &&
                        allvalues[`week_time`]
                      ? param.reset_time.time_ui.display_time
                      : "00:00",
                },
              },
            };
            break;
        }

//parameters[index] = {...paramCopy, ...updatedParam };
  parameters[index] = deepMerge(paramCopy, updatedParam);

      }
      setParameterData([...parameters]);
      paramRef.current = [...parameters];
    }
  };

  const onTimeChange = (time, timeString) => {
    let parameters = [...paramRef.current];
    for (let index = 0; index < paramRef.current.length; index++) {
      let param = paramRef.current[index];

      let updatedParam = {};
      if (paramRef.current[index].name == "series") {
        param.reset_time.time_ui.display_time = timeString;
        parameters[index] = { ...param };
      }
      setParameterData([...parameters]);
      paramRef.current = [...parameters];
    }
  };
  
  const debounceOnChange = React.useCallback(
    debounce(onFormValueChange, 500),
   
    []
  );

  const SaveDetails = async () => {
    let parameters = paramRef.current;
    for (let index = 0; index < parameters.length; index++) {
      let param = parameters[index];

      if (param.name == "series") {
        let UTCDate;
        const [hours, minutes] =  param.reset_time.time_ui.display_time
          .split(":")
          .map(Number);
        if (param.reset_time.type == "year") {
          if (param.reset_time.time_ui.day_number == "last_day") {
            let lastDate = getLastDayOfMonth(parseInt(1));
            lastDate = appendTimeToDate(lastDate, hours, minutes, 0, 0);
            UTCDate = convertToUTC(lastDate);
            param.reset_time["is_last_day"] = true;
          } else if (
            param.reset_time.time_ui.month_number == "1" &&
            param.reset_time.time_ui.day_number == "29"
          ) {
            if (isLeapYear(new Date().getFullYear())) {
              let newDate = createCustomDate(
                new Date().getFullYear(),
                "1",
                "29",
                hours,
                minutes,
                0
              );
              UTCDate = convertToUTC(newDate);
            } else {
              let leapYear = getNextLeapYear(new Date().getFullYear());
              let newDate = createCustomDate(
                leapYear,
                "1",
                "29",
                hours,
                minutes,
                0
              );
              UTCDate = convertToUTC(newDate);
            }
            param.reset_time["is_last_day"] = false;
          } else {
            let newDate = createCustomDate(
              new Date().getFullYear(),
              param.reset_time.time_ui.month_number,
              param.reset_time.time_ui.day_number,
              hours,
              minutes,
              0
            );
            UTCDate = convertToUTC(newDate);
            param.reset_time["is_last_day"] = false;
          }
        } else if (param.reset_time.type == "month") {
          if (param.reset_time.time_ui.day_number == "last_day") {
            let lastDate = getLastDayOfMonth(parseInt(new Date().getMonth()));
            lastDate = appendTimeToDate(lastDate, hours, minutes, 0, 0);
            UTCDate = convertToUTC(lastDate);
            param.reset_time["is_last_day"] = true;
          } else {
            let dateOfMonth;
            if (
              getNextMonthDateIfExceed(
                new Date().getFullYear() +
                  "-" +
                  (new Date().getMonth() + 1) +
                  "-" +
                  param.reset_time.time_ui.day_number
              )
            ) {
              dateOfMonth =createCustomDate(
                new Date().getFullYear() ,
                (new Date().getMonth() + 1) ,
                param.reset_time.time_ui.day_number,hours,minutes,0)
            } else {
              dateOfMonth =
              createCustomDate(
                new Date().getFullYear() ,
                (new Date().getMonth() ) ,
                param.reset_time.time_ui.day_number,hours,minutes,0)
            }
            UTCDate = convertToUTC(new Date(dateOfMonth));
            param.reset_time["is_last_day"] = false;
          }
        } else if (param.reset_time.type == "week") {
          let newDate = getCurrentWeekDate(param.reset_time.time_ui.day_name);
         let lastDate = appendTimeToDate(newDate, hours, minutes, 0, 0);
          UTCDate = convertToUTC(lastDate);
          param.reset_time["is_last_day"] = false;
        }
        

        let seriesInfo = paramRefOriginal.current.find((data) => data.name == 'series');
        if(param.reset_time.type == "week" && param.reset_time.time_ui.day_name == seriesInfo.reset_time.time_ui.day_name
      &&  param.reset_time.time_ui.display_time == seriesInfo.reset_time.time_ui.display_time && param.reset_time.type == seriesInfo.reset_time.type )
      {
        param.reset_time["time"] = seriesInfo.reset_time.time;
      }
      else if(param.reset_time.type == "year" && param.reset_time.time_ui.day_number == seriesInfo.reset_time.time_ui.day_number
      &&  param.reset_time.time_ui.display_time == seriesInfo.reset_time.time_ui.display_time
      &&  param.reset_time.time_ui.month_number == seriesInfo.reset_time.time_ui.month_number && param.reset_time.type == seriesInfo.reset_time.type )
      {
        param.reset_time["time"] = seriesInfo.reset_time.time;
      }
      else if(param.reset_time.type == "month" && param.reset_time.time_ui.day_number == seriesInfo.reset_time.time_ui.day_number
      &&  param.reset_time.time_ui.display_time == seriesInfo.reset_time.time_ui.display_time && param.reset_time.type == seriesInfo.reset_time.type
       )
      {
        param.reset_time["time"] = seriesInfo.reset_time.time;
      }
      else{
        param.reset_time["time"] = UTCDate;

      }

       if (param.reset_time.type == "none") {
        param.reset_time.status = false;
        param.reset_time["time"] = '';
      }
      else{
        param.reset_time.status = true;
      }

        param.reset_time.time_ui.month_number = parseInt(
          param.reset_time.time_ui.month_number
        );
        if(param.reset_time.time_ui.day_number != "last_day")
          {
        param.reset_time.time_ui.day_number = parseInt(
          param.reset_time.time_ui.day_number
        );
      }
        parameters[index] = { ...param };
      }
    }
    try {
      const resp = await updateJobCardSerialNumberParam(parameters);
      if (!resp.error) {
        
        setAlert(true);
        setTimeout(() => {
          setAlert(false);
         props.onSave();
         props.onClose();
        }, 3000);
      }
    } catch (error) {
      console.log(error);
    //   setResponse(error.response.data);
      setError(true);
      setTimeout(() => {
        setError(false);
      }, 2000);
    }
  };

  const onFinish = () => {
    form.submit();
  };

  const validateTime = (rule, value) => {
    if (!value) {
      return Promise.reject("Please select a time");
    }
    return Promise.resolve();
  };

  const moveItem = (dragIndex, hoverIndex) => {
    isDragged.current = true;
    const draggedItem = [dragIndex];
    const draggedData = paramRef.current[dragIndex];
   setTimeout(() => {
    
      const newItems = [...paramRef.current];
      newItems.splice(dragIndex, 1);
      newItems.splice(hoverIndex, 0, draggedData);
   
   
      paramRef.current = newItems;
      setParameterData(newItems);
   }, 1000); 
  };

  const toggleClicked = (index) => {
    setActiveList((prevItems) => {
      let newItems = [...prevItems];
      newItems.forEach((item, i) => {
        if (i == index) {
          newItems[i] = !newItems[index];
        } else {
          newItems[i] = false;
        }
      });
      return newItems;
    });
    
  };

  const toggleUnclicked = (index) => {
    setActiveList((prevItems) => {
      return prevItems.map((item, i) => {
        return { ...item, clicked: false };
      });
    });
  };

  const Card = ({ data,index }) => {
    const [, drag] = useDrag({
      type: 'card', // Define the type here
      item: { data, index },
      collect: (monitor) => ({
        isDragging: !!monitor.isDragging(),
      }),
    });
    const [{ isDragging }, drop] = useDrop({
      accept:'card',
      hover(item) {
        // if (item.index !== index) {
        //   // Optionally, you can update the item's index here as well.
        //   // This ensures that it's updated during the drag operation.
        //  // moveItem(item.index, index);
        //   item.index = index;
        // }
      },
      drop(item) {
        setBorderIndex(null);
        // This function will be called when an item is dropped.
        // You can perform any necessary actions here, such as moving the item.
        moveItem(item.index, index);
      },
    });
   
    
    return (
     
        <div
          
          style={{ display: "flex", alignItems: "flex-start" ,
          borderTop: (borderIndex === index) ? "2px solid var(--theme-color)": "none",
          //scale: activeList[index] && "1.03",
        }}
        >
          
          <div
                      className="drawerField removeStar"
                      style={{ paddingTop: "0",width:'100%', }}
                    >
                    
                      <div
                        className="titleWithText dFlex"
                        style={{
                          justifyContent: "space-between",
                          padding: "15px 0px 0px 0px",
                        }}
                      >
                        <div
                        ref={(node) => drag(drop(node))}
                        // onDropCapture={() => setBorderIndex(null)}
                        onDragEndCapture={() => setBorderIndex(null)}
                        onDragEnterCapture={() => setBorderIndex(index)}
                        >
                          <svg
            style={{
              // position: "absolute",
              // top: "35%",
              // alignSelf: "center",
              width: "16px",
              height:'16px',
              // opacity: "0.7",
              // left: "50%",
              // transform: "translate(-100%, -50%)",
              color: "var(--color-text-title)",
              marginTop:  data.name != "series" ? '5px' : '0px',
              marginRight:'5px',
              cursor:" grab"
            }}
            viewBox="64 64 896 896"
            focusable="false"
            data-icon="holder"
            width="1em"
            height="1em"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z"></path>
          </svg>
          <h5 style={{ alignSelf: "center" ,display:'inline-block',paddingBottom:'3px',verticalAlign:'middle'}}>
                          Parameter {index + 1}
                        </h5></div>{" "}
                        
                        <GlobalSet
                          className="specialBtn adjCntBtn"
                          style={{ width: "calc(100% - 125px)" }}
                        >
                          <Styled styled={{ display: "flex" }}>
                            {data.name != "series" && (
                              <Tooltip
                                placement="bottomRight"
                                title={"Delete Parameter"}
                                className="edit-tooltip"
                                getPopupContainer={(triggerNode) => triggerNode}
                              >
                                <Button
                                  className="textTypeBtn textBtnIcon"
                                  style={{ marginLeft: "0" }}
                                  onClick={() => onDeleteParamater(index)}
                                >
                                  <Iconmoon
                                    icon="delete"
                                    size={14}
                                    color="#EA655B"
                                  />
                                  Delete
                                </Button>
                              </Tooltip>
                            )}
                          </Styled>
                        </GlobalSet>
                      </div>
                      <div
                        style={{
                          justifyContent: "space-between",
                          marginBottom: "10px",
                          marginTop: data.name != "series" ? '-5px' : '0px',
                        }}
                      >
                        {" "}
                        <p style={{color: "var(--color-text-title)"}}>
                          {" "}
                          This parameter will appear {indexValue[`${index}`]} in
                          the sequence
                        </p>
                      </div>
                      <Row className="centerAlign justifyCSBetween" style={{marginBottom:'10px !important'}}>
                        <Col span={12} style={{marginBottom:'-20px'}}>
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0", paddingRight: "5px" }}
                          >
                            <Form.Item
                              label="Parameter Type"
                              name={`param_type${index}`}
                              rules={[
                                {
                                  required: true,

                                  message: "This field is required",
                                },
                              ]}
                              className="dBlock"
                              initialValue={data.name}
                            >
                              <Select
                                placeholder="Parameter"
                                suffixIcon={<DownArrowDraw />}
                                onChange={(e) => {
                                  onParameterTypeChange(e, index)
                                }
                                }
                                disabled={data.name == "series"}
                              >
                                {parameterList.map((param) => (
                                  <Option
                                    key={param.value}
                                    value={param.value}
                                    disabled={param.disabled}
                                  >
                                    {param.label}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </div>
                        </Col>

                        <Col span={12} style={{marginBottom:'-20px'}}>
                          {data.name == "fixed_code" && (
                            <div
                              className="boxFormType"
                              style={{ marginLeft: "5px" }}
                            >
                            
                              <Form.Item
                                label="Parameter Value"
                                name={`code${index}`}
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    pattern: new RegExp(/^[a-zA-Z0-9]*$/),
                                    message: "Alphanumeric values is accepted",
                                  },
                                  {
                                    max: 6,
                                    message: "Max 6 characters are allowed ",
                                  },
                                ]}
                                className="dBlock"
                                initialValue={data.value}
                              >
                                <Input
                                  placeholder="Enter Code"
                                  // onChange={(e) => {
                                  //   setValidateData({
                                  //     ...validateData,
                                  //     width: e.target.value,
                                  //   })
                                  // }
                                  // }
                                />
                              </Form.Item>
                            </div>
                          )}
                          {data.name == "year" && (
                            <div
                              className="boxFormType"
                              style={{ marginLeft: "5px" }}
                            >
                              <Form.Item
                                label="Parameter Format"
                                name={`year${index}`}
                                initialValue={"2001,2002,2003,…"}
                                className="dBlock"
                              >
                                <Input disabled />
                              </Form.Item>
                            </div>
                          )}
                          {data.name == "month" && (
                            <div
                              className="boxFormType"
                              style={{ marginLeft: "5px" }}
                            >
                              <Form.Item
                                label="Parameter Format"
                                name={`month${index}`}
                                initialValue={data.type}
                                className="dBlock"
                              >
                                <Select
                                  placeholder="Parameter"
                                  suffixIcon={<DownArrowDraw />}
                                  // onChange={}
                                >
                                  {monthType.map((param) => (
                                    <Option
                                      key={param.value}
                                      value={param.value}
                                    >
                                      {param.label}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </div>
                          )}
                          {data.name == "day" && (
                            <div
                              className="boxFormType"
                              style={{ marginLeft: "5px" }}
                            >
                              <Form.Item
                                label="Parameter Format"
                                name={`day${index}`}
                                initialValue={"01,02…30,31"}
                                className="dBlock"
                              >
                                <Input placeholder="Width" disabled />
                              </Form.Item>
                            </div>
                          )}
                          {data.name == "machine" && (
                            <div
                              className="boxFormType"
                              style={{ marginLeft: "5px" }}
                            >
                              <Form.Item
                                label="Parameter Format"
                                name={`machine${index}`}
                                initialValue={data.type}
                                className="dBlock"
                              >
                                <Select
                                  placeholder="Parameter"
                                  suffixIcon={<DownArrowDraw />}
                                  // onChange={}
                                >
                                  {machineParam.map((param) => (
                                    <Option
                                      key={param.value}
                                      value={param.value}
                                    >
                                      {param.label}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </div>
                          )}
                          {data.name == "series" && (
                            <div
                              className="boxFormType"
                              style={{ marginLeft: "5px" }}
                            >
                              <Form.Item
                                label="Starting Number"
                                name={`series${index}`}
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    pattern: new RegExp(/^[0-9]*$/),
                                    message: "Numeric values is accepted",
                                  },
                                  {
                                    max: 8,
                                    message: "Max 8 characters are allowed ",
                                  },
                                ]}
                                className="dBlock"
                                initialValue={data.initiator}
                              >
                                <Input placeholder="Enter Number"
                                 />
                              </Form.Item>
                            </div>
                          )}
                        </Col>
                      </Row>
                      {data.name == "series" && (
                        <>
                          <Row className="centerAlign justifyCSBetween">
                            <Col span={24} style={{marginBottom:'-20px'}}>
                              <div
                                className="boxFormType"
                                style={{
                                  marginBottom: "0",
                                  marginRight: "5px",
                                }}
                              >
                                  <JobConfigStyle>
                                <Form.Item
                                  label= { <div style={{ display: 'flex', alignItems: 'center' }}>Series Reset Condition&nbsp;
                                  <Styled style={{ display: "inline-flex",marginBottom:'5px' }}>
                                  <Tooltip
                                    placement="bottomRight"
                                    title={
                                      "The series will be reset when the selected condition is met. For example , If the condition is Year Change, the series will be reset when a new year starts."
                                    }
                                    overlayStyle={{ zIndex: 9999 }}
                                    className="edit-tooltip"
                                    getPopupContainer={(triggerNode) => triggerNode}
                                  >
                                    <span className="infoIcon"></span>
                                  </Tooltip>
                                </Styled>
                                </div>}
                                  name="reset_condition"
                                  rules={[
                                    {
                                      required: true,

                                      message: "This field is required",
                                    },
                                  ]}
                                  className="dBlock"
                                  initialValue={data.reset_time.type}
                                >
                                  <Select
                                    placeholder="Select separator"
                                    suffixIcon={<DownArrowDraw />}
                                    // onChange={}
                                  >
                                    {resetCondition.map((param) => (
                                      <Option
                                        key={param.value}
                                        value={param.value}
                                      >
                                        {param.label}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                                </JobConfigStyle>
                              </div>
                            </Col>
                          </Row>
                          {data.reset_time.type == "year" && (
                            <Row className="centerAlign justifyCSBetween">
                              <Col span={8} style={{marginBottom:'-20px'}}>
                                <div
                                  className="boxFormType"
                                  style={{
                                    marginBottom: "0",
                                    paddingRight: "5px",
                                    paddingTop: "2px",
                                  }}
                                >
                                   <JobConfigStyle>
                                  <Form.Item
                                    label= { <div style={{ display: 'flex', alignItems: 'center' }}>Year Config.&nbsp;
                                    <Styled style={{ display: "inline-flex",marginBottom:'5px' }}>
                                    <Tooltip
                                      placement="bottomRight"
                                      title={
                                        "Year Configuration describes the start of the year as per business."
                                      }
                                      overlayStyle={{ zIndex: 9999 }}
                                      className="edit-tooltip"
                                      getPopupContainer={(triggerNode) => triggerNode}
                                    >
                                      <span className="infoIcon"></span>
                                    </Tooltip>
                                  </Styled>
                                  </div>}
                                    name="year_month"
                                    rules={[
                                      {
                                        required: true,

                                        message: "This field is required",
                                      },
                                    ]}
                                    className="dBlock"
                                    initialValue={
                                      data.reset_time.time_ui.month_name
                                    }
                                  >
                                    <Select
                                      placeholder="Month"
                                      suffixIcon={<DownArrowDraw />}
                                      // onChange={}
                                    >
                                      {months.map((param) => (
                                        <Option
                                          key={param.value}
                                          value={param.value}
                                        >
                                          {param.label}
                                        </Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                  </JobConfigStyle>
                                </div>
                              </Col>
                              <Col span={8} style={{marginBottom:'-20px'}}>
                                <div
                                  className="boxFormType"
                                  style={{
                                    marginBottom: "0",
                                    paddingLeft:'5px',
                                  }}
                                >
                                  <Form.Item
                                    label=" "
                                    name="year_day"
                                    rules={[
                                      {
                                        required: true,

                                        message: "This field is required",
                                      },
                                    ]}
                                    className="dBlock"
                                    initialValue={
                                      data.reset_time.time_ui.day_number
                                    }
                                  >
                                    <Select
                                      placeholder="Day"
                                      suffixIcon={<DownArrowDraw />}
                                      // onChange={}
                                    >
                                      {Array.from(
                                        Array(
                                          dates[
                                            data.reset_time.time_ui.month_number
                                          ]
                                        )
                                      ).map((s, i) => (
                                        <Option
                                          key={i < 9 ?  (i + 1) : i + 1}
                                          value={i < 9 ?  (i + 1) : i + 1}
                                        >
                                          {i < 9 ? "0" + (i + 1) : i + 1}
                                        </Option>
                                      ))}
                                      {data.reset_time.time_ui.month_name ==
                                        "february" && (
                                        <Option
                                          key={"last_day"}
                                          value={"last_day"}
                                        >
                                          Last Day
                                        </Option>
                                      )}
                                    </Select>
                                  </Form.Item>
                                </div>
                              </Col>
                              <Col span={8} style={{marginBottom:'-20px'}}>
                                <div
                                  className="boxFormType"
                                  style={{ marginBottom: "0",paddingLeft:'10px' }}
                                >
                                  <Form.Item
                                    label=" "
                                    name="year_time"
                                    rules={[
                                      {
                                        required: true,

                                        message: "This field is required",
                                      },
                                    ]}
                                    className="dBlock"
                                    initialValue={
                                      data.reset_time.time_ui.display_time
                                    }
                                  >
                                    <TimePickerStyle>
                                      <TimePicker
                                        format="HH:mm"
                                        defaultValue={moment(
                                          data.reset_time.time_ui.display_time,
                                          "HH:mm"
                                        )}
                                        hideDisabledOptions
                                        clearIcon={null}
                                        showNow={false}
                                        allowClear={true}
                                        onChange={onTimeChange}
                                      />
                                    </TimePickerStyle>
                                  </Form.Item>
                                </div>
                              </Col>
                            </Row>
                          )}
                          {data.reset_time.type == "month" && (
                            <Row className="centerAlign justifyCSBetween">
                              <Col span={12} style={{marginBottom:'-20px'}}>
                                <div
                                  className="boxFormType"
                                  style={{
                                    marginBottom: "0",
                                    paddingRight: "5px",
                                    paddingTop: "2px",
                                  }}
                                >
                                  <JobConfigStyle>
                                  <Form.Item
                                    label= { <div style={{ display: 'flex', alignItems: 'center' }}>Month Config&nbsp;
                                    <Styled style={{ display: "inline-flex",marginBottom:'5px' }}>
                                    <Tooltip
                                      placement="bottomRight"
                                      title={
                                        "Month Configuration describes the start of the month as per business."
                                      }
                                      overlayStyle={{ zIndex: 9999 }}
                                      className="edit-tooltip"
                                      getPopupContainer={(triggerNode) => triggerNode}
                                    >
                                      <span className="infoIcon"></span>
                                    </Tooltip>
                                  </Styled>
                                  </div>}
                                    name="month_day"
                                    rules={[
                                      {
                                        required: true,

                                        message: "This field is required",
                                      },
                                    ]}
                                    className="dBlock"
                                    initialValue={
                                      data.reset_time.time_ui.day_number
                                    }
                                  >
                                    <Select
                                      placeholder="Day"
                                      suffixIcon={<DownArrowDraw />}
                                      // onChange={}
                                    >
                                      {Array.from(Array(31)).map((s, i) => (
                                        <Option
                                        key={i < 9 ?  (i + 1) : i + 1}
                                        value={i < 9 ?  (i + 1) : i + 1}
                                      >
                                        {i < 9 ? "0" + (i + 1) : i + 1}
                                      </Option>
                                      ))}
                                      <Option
                                        key={"last_day"}
                                        value={"last_day"}
                                      >
                                        Last Day
                                      </Option>
                                    </Select>
                                  </Form.Item>
                                  </JobConfigStyle>
                                </div>
                              </Col>
                              <Col span={12} style={{marginBottom:'-20px'}}>
                                <div
                                  className="boxFormType"
                                  style={{ marginBottom: "0",paddingLeft:'5px' }}
                                  
                                >
                                  <Form.Item
                                    label=" "
                                    name="month_time"
                                    rules={[
                                      {
                                        required: true,

                                        message: "This field is required",
                                      },
                                    ]}
                                    className="dBlock"
                                    initialValue={moment(
                                      data.reset_time.time_ui.display_time,
                                      "HH:mm"
                                    )}
                                  >
                                    <TimePickerStyle>
                                      <TimePicker
                                        format="HH:mm"
                                        defaultValue={moment(
                                          data.reset_time.time_ui.display_time,
                                          "HH:mm"
                                        )}
                                        onChange={onTimeChange}
                                        clearIcon={null}
                                      />
                                    </TimePickerStyle>
                                  </Form.Item>
                                </div>
                              </Col>
                            </Row>
                          )}
                          {data.reset_time.type == "week" && (
                            <Row className="centerAlign justifyCSBetween">
                              <Col span={12} style={{marginBottom:'-20px'}}>
                                <div
                                  className="boxFormType"
                                  style={{
                                    marginBottom: "0",
                                    paddingRight: "5px",
                                    paddingTop: "2px",
                                  }}
                                >
                                  <JobConfigStyle>
                                  <Form.Item
                                    label= { <div style={{ display: 'flex', alignItems: 'center' }}>Week Configuration&nbsp;
                                    <Styled style={{ display: "inline-flex",marginBottom:'5px' }}>
                                    <Tooltip
                                      placement="bottomRight"
                                      title={
                                        "Week Configuration describes the start of the week as per business."
                                      }
                                      overlayStyle={{ zIndex: 9999 }}
                                      className="edit-tooltip"
                                      getPopupContainer={(triggerNode) => triggerNode}
                                    >
                                      <span className="infoIcon"></span>
                                    </Tooltip>
                                  </Styled>
                                  </div>}
                                    name="week_day"
                                    rules={[
                                      {
                                        required: true,

                                        message: "This field is required",
                                      },
                                    ]}
                                    className="dBlock"
                                    initialValue={
                                      data.reset_time.time_ui.day_name
                                    }
                                  >
                                    <Select
                                      placeholder="Week"
                                      suffixIcon={<DownArrowDraw />}
                                      // onChange={}
                                    >
                                      {days.map((param) => (
                                        <Option
                                          key={param.value}
                                          value={param.value}
                                        >
                                          {param.label}
                                        </Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                  </JobConfigStyle>
                                </div>
                              </Col>
                              <Col span={12}style={{marginBottom:'-20px'}}>
                                <div
                                  className="boxFormType"
                                  style={{ marginBottom: "0" ,paddingLeft:'5px'}}
                                >
                                  <Form.Item
                                    label=" "
                                    name="week_time"
                                    rules={[
                                      {
                                        required: true,

                                        message: "This field is required",
                                      },
                                    ]}
                                    className="dBlock"
                                    initialValue={moment(
                                      data.reset_time.time_ui.display_time,
                                      "HH:mm"
                                    )}
                                  >
                                    <TimePickerStyle>
                                      <TimePicker
                                        format="HH:mm"
                                        defaultValue={moment(
                                          data.reset_time.time_ui.display_time,
                                          "HH:mm"
                                        )}
                                        clearIcon={null}
                                        onChange={onTimeChange}
                                      />
                                    </TimePickerStyle>
                                  </Form.Item>
                                </div>
                              </Col>
                            </Row>
                          )}

                          <Row className="centerAlign justifyCSBetween">
                            <Col span={24} style={{marginBottom:'-20px'}}>
                              <div
                                className="boxFormType"
                                style={{
                                  marginBottom: "0",
                                  marginRight: "5px",
                                }}
                              >
                                <JobConfigStyle>
                                <Form.Item
                                  label= { <div style={{ display: 'flex', alignItems: 'center' }}>Series Hierarchy&nbsp;
                                    <Styled style={{ display: "inline-flex",marginBottom:'5px' }}>
                                    <Tooltip
                                      placement="bottomRight"
                                      title={
                                        "The series will be maintained on the level of hierarchy. For example, if the hierarchy is Paper Machine, each machine will have it’s own series."
                                      }
                                      overlayStyle={{ zIndex: 9999 }}
                                      className="edit-tooltip"
                                      getPopupContainer={(triggerNode) => triggerNode}
                                    >
                                      <span className="infoIcon"></span>
                                    </Tooltip>
                                  </Styled>
                                  </div>}
                                  name="series_hierarchy"
                                  rules={[
                                    {
                                      required: true,

                                      message: "This field is required",
                                    },
                                  ]}
                                  className="dBlock"
                                  initialValue={data.hierarchy}
                                >
                                  <Select
                                    placeholder="Select Hierarchy"
                                    suffixIcon={<DownArrowDraw />}
                                    // onChange={}
                                  >
                                    {seriesHierarchy.map((param) => (
                                      <Option
                                        key={param.value}
                                        value={param.value}
                                      >
                                        {param.label}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                                </JobConfigStyle>
                              </div>
                            </Col>
                          </Row>
                        </>
                      )}
                      <Row className="centerAlign justifyCSBetween">
                        <Col span={24} style={{}}>
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0", marginRight: "5px" }}
                          >
                            <Form.Item
                              label="Separator"
                              name={`separator${index}`}
                              className="dBlock"
                              initialValue={data?.separator?.value}
                            >
                              <Select
                                placeholder="Select separator"
                                suffixIcon={<DownArrowDraw />}
                                // onChange={}
                              >
                                {separators.map((param) => (
                                  <Option key={param.value} value={param.value}>
                                    {param.label}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                    </div>
        </div>

    );
  };

  return parameterData &&
    parameterData.length &&
    parameterList &&
    parameterList.length ? (
    <RightDrawerSidebar
      title={ "Job Card Number Configuration"}
      visible={props.visible}
      onClose={() => {
        //setExchangeRateData("");
        props.onClose();
      }}
    >
       
       {error && (
          <AlertContainer
            color="red toaster"
            icon={alertRed}
            closeIcon={true}
            setClose={setError}
            msg={
              "Error while updating jobcard code config"
            }
          />
        )}
        {alert && (
        <AlertContainer
          color={"green"}
          icon={alertGreen}
          msg={'jobcard code config updated'}
        />
      )}
      <RightDrawerContainer>
        <AlertContainer
          color="blue"
          icon={alertBlue}
          msg="Select the parameters from the dropdown and separator as per the required sequence"
        />
       
        <div className="resetPassForm removePadLeft">
          <DetailFields>
            <HaberForm>
              <Form
                name="basic"
                autoComplete="off"
                className="haberLogin haberSignup"
                style={{ marginTop: "0" }}
                form={form}
                onValuesChange={debounceOnChange}
                onFinish={SaveDetails}
              >
                {/* <TimePickerStyle>
                <StyledTimePicker 
                               format="HH:mm" 
                                  defaultValue={defaultTime} // Set default time
                                  open
                                /></TimePickerStyle> */}
                                <DndProvider backend={HTML5Backend}>
                {parameterData.map((data, index) => {
                  return (
                    
                    <Card
                    data={data}
                    index={index}
                    ></Card>
                  );
                })}
                </DndProvider>
                <GlobalSet
                  style={{
                    textAlign: "left",
                    marginTop: "25px",
                    height: "100px",
                  }}
                >
                  <Button
                    className="textTypeBtn textBtnIcon"
                    style={{ marginLeft: "0", background: "none" }}
                    disabled={parameterData.length >= 6}
                    onClick={onAddParameter}
                  >
                    <Iconmoon icon="addcircle" size={14} color="#EA655B" />
                    Add a Parameter
                  </Button>
                </GlobalSet>
                <Row className="centerAlign justifyCSBetween">
                  <GlobalSet
                    style={{ textAlign: "left", marginTop: "16px" }}
                  ></GlobalSet>
                </Row>
                <div
                  className="buttonFlex fixedBtm"
                  style={{ flexDirection: "column", width: "100%" }}
                >
                  <div style={{ flexDirection: "row", width: "100%" }}>
                    <div className="titleWithText">
                      <h5>Preview</h5>
                      <p style={{ paddingBottom: "10px" }}>
                        Preview of the configured reel number
                      </p>
                    </div>
                    <Form.Item
                      name="previewCode"
                      rules={[{ required: true }]}
                      className="selectForm"
                    >
                      <Input disabled />
                    </Form.Item>
                  </div>
                  <div style={{ flexDirection: "row", width: "100%" }}>
                    <Button
                      className="themeBtn"
                      key="submit"
                      // disabled={!roles.edit_own}
                      htmlType="submit"
                      disabled = {!userDetails.roles.advanced_settings.edit || isSaveDisable}
                    >
                      <Iconmoon icon="addcircle" size={16} color="#ffffff" />
                      Save
                    </Button>
                  </div>
                </div>
              </Form>
            </HaberForm>
          </DetailFields>
        </div>
      </RightDrawerContainer>
    </RightDrawerSidebar>
  ) : (
    ""
  );
};

export default SerialNumberConfigDrawer;
